export default __webpack_public_path__ + "static/php-91a319c749e7b7df01d9bd2f083f2ef5.svg";